import { useFieldContext } from "../form-context";

import { JSX, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { FormControl, FormHelperText, FormLabel, SxProps } from "@mui/material";
import { FieldApi } from "@tanstack/react-form";

export interface BaseFieldProps {
  children: ReactNode;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  sx?: SxProps;
  showError?: boolean;
}

export function BaseField({
  children,
  fullWidth,
  required,
  disabled,
  sx,
  showError = true,
}: BaseFieldProps): JSX.Element {
  const { t } = useTranslation();
  const field = useFieldContext();

  return (
    <FormControl
      sx={sx}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
    >
      <FormLabel>{t("AS:dialog.requestQuote.label." + field.name)}</FormLabel>
      {children}
      {showError && getErrorMessage(field) ? (
        <FormHelperText error>{getErrorMessage(field)}</FormHelperText>
      ) : null}
    </FormControl>
  );
}

export function getErrorMessage(
  /* eslint-disable @typescript-eslint/no-explicit-any */
  field: FieldApi<
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >,
  /* eslint-enable @typescript-eslint/no-explicit-any */
): string {
  if (field.state.meta.errorMap) {
    const errorOnSubmit = field.state.meta.errorMap["onSubmit"];
    const errorOnBlur = field.state.meta.errorMap["onBlur"];
    return errorOnSubmit || errorOnBlur || "";
  }

  return "";
}
